module.exports = __webpack_public_path__ + "static/media/discount.3ad89d64.png";